export enum SubscriptionScheduledOperationType {
  Cancel,
  Downgrade
}
